import { URLParsedEvent } from '../../../events';
import { BookLocation } from 'types';
import locationLogic from '..';

/**
 * @method getLocationForPath
 * @param {Book} book - a book object, needed to build a location
 * @param {String} path - string representing an absolute URL path
 */
const getLocationForPath = (book, path) => {
  const url = new URL(`http://localhost${path}`);

  // Ensure book passed in
  if (!book) {
    console.warn('A book is necessary to build a location from a URL.');
    return null;
  }

  // Parse out the document and book id
  let {
    groups: { bookPk, documentNumber },
  } = /^\/read\/(?<bookPk>\d+)\/(?<documentNumber>\d+)/.exec(url.pathname);

  // Ensure book id match
  if (book.pk !== parseInt(bookPk)) {
    console.warn(
      'Book object passed to getLocationForPath does not have a RedShelf ID that matches the ID in the url.',
    );
    return null;
  }

  // Normalize documentNumber
  documentNumber = parseInt(documentNumber);

  // Create an event
  const event = new URLParsedEvent();

  // Fall back: start at the beginning of the document
  return new BookLocation({
    book,
    documentNumber,
    event,
    ...locationLogic.getHashParameter(url.hash),
  });
};

export default getLocationForPath;
